import React, { useState, useEffect } from 'react';
import { Button } from 'reactstrap';

//Components
import TabelaListagem from '../../../../components/TabelaListagem/TabelaListagem';
import FormularioStepper from './Components/FormularioStepper';

//Api
import formulario_api from '../../../../api/formulario_api';

//Helpers
import { showMessage } from '../../../../helpers/message';

//Context
import { useAuth } from '../../../../context/auth';

// Constants
import { actionsTable } from '../../../../constants/MaterialTable';

export default function Formularios({ permissoes }) {
    //Pegando o estado de controle do loading na tela
    const { setLoading } = useAuth();

    //Estado de controle de exibição da tela de cadastro de formularios
    const [cadastro, setCadastro] = useState(false);

    //Estado de controle da lista de formularios
    const [formularios, setFormularios] = useState([]);

    //Estado de controle de visualização de um formulario especifico
    const [idFormulario, setIdFormulario] = useState(null);

    //Variavel de controle de edição da tela
    const editavel = permissoes.filter(permissao => permissao.acao == "Editar").length > 0;

    //Função do botão visualizar da lista
    const visualizar = (formulario) => {
        setIdFormulario(formulario.id)
    };

    //Ações que a tabela terá
    const actions = [actionsTable.visualizar(visualizar)];

    //Cabeçalhos que a tabela terá
    const headers = [
        { value: "Identificação", objectValue: "identificacao", align: "left" },
        { value: "Status", objectValue: "status", align: "left" }
    ]

    //Função que carrega a lista de formularios
    const loadFormularios = () => {
        setLoading(true);
        formulario_api.getList().then(response => {
            setFormularios(response.data);
        }).catch(e => showMessage("Erro", e.message, "error", null))
            .finally(f => setLoading(false));
    }
    useEffect(() => {
        loadFormularios();
    }, []);

    const btnVoltar = () => {
        setCadastro(false);
        setIdFormulario(null);
        loadFormularios();
    };

    if (cadastro || idFormulario) {
        return <FormularioStepper
            btnVoltar={btnVoltar}
            id={idFormulario}
            editavel={editavel}
        />
    }

    return (
        <>
            <div className='d-flex align-items-center justify-content-between mb-4'>
                <h4 className='text-secondary m-0'>Formulários</h4>
                <Button color='success' onClick={() => { setCadastro(true) }}>+ Cadastrar</Button>
            </div >
            <TabelaListagem
                actions={actions}
                title={"Lista de Formulários"}
                options={{ print: false, search: true, pagination: true }}
                headers={headers}
                items={formularios}
            />
        </>
    )
}